// extracted by mini-css-extract-plugin
export default {"modal-container":"NewGroupModal_modal-container__aOcMS"};